import styled from '@emotion/styled'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import { AuthFieldType } from './auth-field-type'

const FieldContainer = styled.div`
  margin-bottom: 15px;
`

interface AuthFieldProps {
  authField: AuthFieldType
  newConnection: boolean
  onFieldChange: (value: string, key: string) => void
}

export const AuthField = ({ authField, newConnection, onFieldChange }: AuthFieldProps) => {
  const getHelperText = (showText: boolean): string | null =>
    showText ? authField.errorText || '*Required' : null

  const textFieldControlledValue = authField.fieldValue || '' // disallow default undefined value.
  return (
    <FieldContainer>
      <TextField
        style={{ width: '100%', marginBottom: 12 }}
        variant="outlined"
        required={!authField.isOptional}
        label={authField.fieldLabel}
        value={textFieldControlledValue}
        type={authField.isSecret ? 'password' : 'text'}
        onChange={e => {
          onFieldChange(e.target.value, authField.fieldKey)
        }}
        helperText={getHelperText(
          authField.hasError ? authField.hasError : newConnection && !authField.fieldValue,
        )}
      />
      {authField.description && <Typography variant="caption">{authField.description} </Typography>}
      {authField.fieldDescriptionElement ? authField.fieldDescriptionElement : null}
    </FieldContainer>
  )
}
